import type { IconType } from 'react-icons'
import {
  MdBlock,
  MdOutlineDescription,
  MdOutlineGridView,
  MdOutlineInventory2,
  MdOutlineNotifications,
  MdOutlinePendingActions,
  MdOutlinePerson,
  MdOutlineSettings,
  MdUndo,
} from 'react-icons/md'

import { Pages } from '@/shared/config/pages'
import type { Permission } from '@/shared/auth/permissions'

export interface NavItem {
  label: string
  icon: IconType
  to: string
  roles?: ReadonlyArray<Permission>
  badge?: number
  ready?: boolean
}

export interface NavGroup {
  id: string
  label: string
  items: ReadonlyArray<NavItem>
}

export const NAV_GROUPS: ReadonlyArray<NavGroup> = [
  {
    id: 'geral',
    label: 'navigation:group_geral',
    items: [
      {
        label: 'navigation:dashboard',
        icon: MdOutlineGridView,
        to: Pages.DASHBOARD,
      },
      {
        label: 'navigation:dashboard_finalizers',
        icon: MdOutlineGridView,
        to: Pages.DASHBOARD_FINALIZERS,
      },
      {
        label: 'navigation:processing',
        icon: MdOutlinePendingActions,
        to: Pages.PROCESSING,
      },
      {
        label: 'navigation:reports',
        icon: MdOutlineDescription,
        to: Pages.REPORTS,
      },
      {
        label: 'navigation:block_order',
        icon: MdBlock,
        to: Pages.BLOCK_ORDER,
      },
    ],
  },
  {
    id: 'fulfillment',
    label: 'navigation:group_fulfillment',
    items: [
      {
        label: 'navigation:shipments',
        icon: MdOutlineInventory2,
        to: Pages.SHIPMENTS,
      },
      {
        label: 'navigation:returns',
        icon: MdUndo,
        to: Pages.RETURNS,
      },
    ],
  },
]

export const FOOTER_NAV_ITEMS: ReadonlyArray<NavItem> = [
  {
    label: 'navigation:notifications',
    icon: MdOutlineNotifications,
    to: Pages.NOTIFICATIONS,
    badge: 30,
  },
  {
    label: 'navigation:profile',
    icon: MdOutlinePerson,
    to: Pages.PROFILE,
    ready: true,
  },
  {
    label: 'navigation:settings',
    icon: MdOutlineSettings,
    to: Pages.SETTINGS,
    ready: true,
  },
]

export const PUBLIC_ROUTES = new Set<string>([
  Pages.LOGIN,
  Pages.RESET_PASSWORD,
  Pages.CONFIRM_ACCOUNT,
  Pages.NO_ACCESS,
])
